export const environment = {
    production: false,
    trackingId : "UA-136336878-4",
    api : "https://ports.esp-stg.svespg1.vmw.saas.broadcom.com/",
    ssoURL : "https://myvmware-stg.workspaceair.com/SAAS/API/1.0/GET/apps/launch/app/1b818c47-7b5a-49c3-b2df-8b834a46a527",
    clientId : "aed572517d2db4d2bb7fc504796972f4",
  };
